<template>
  <el-container class="v_layout">
    <!--左侧菜单栏-->
    <LayoutSidebar :isCollapse="isCollapse" />
    <!--右侧-->
    <el-container>
      <!--头部-->
      <LayoutHeader :isCollapse="isCollapse" @collapse="isCollapse = !isCollapse"/>
      <!--内容-->
      <el-main style="padding: 0px;">
        <transition name="g-fade" mode="out-in">
          <router-view />
        </transition>
      </el-main>
    </el-container>

    <AudioPlay ref="AudioPlay" :allSliceFlag="$global.allSliceFlag"/>

    <DaoQiPop ref="DaoQiPop"/>
  </el-container>
</template>

<script>
// import { apiInit } from '@/utils/api.js'
import LayoutSidebar from "./LayoutSidebar";
import LayoutHeader from "./LayoutHeader";
import { addEventListener } from '@/utils/index.js'
import Bus from '@/utils/bus.js'
import DaoQiPop from '@/components/DaoQiPop.vue'
export default {
  name: "Layout",

  components: {
    DaoQiPop,
    LayoutSidebar,
    LayoutHeader,
  },

  created() {
    this.triggerAllSlicePlay()
    Bus.$on('audioChanged', (audioUrl) => {
      this.$refs.AudioPlay.changeAudioUrl(audioUrl)
    })
    this.$ws.addFn('msg', (data) => {
      Bus.$emit('busReceiveMsg', data)
      let msg = data.msg
      if (data.send_type !== 1) {
        msg = ''
      } else {
        if (data.type === 1) {
          msg = '[图片]'
        } else if (data.type === 2) {
          msg = '[文件]'
        }
      }
      if(this.$refs.AudioPlay) this.$refs.AudioPlay.receivePlay()
      // 系统级桌面通知（已授权才发）
      if(this.permissionStatus === 'granted'){
        this.Notification(data.name, msg, data.user_id)
        return;
      }
      if(this.$route.path === '/chat') return
      // 页面内右下角弹窗
      this.$notify({
        title: data.name,
        iconClass: 'iconfont icon-xiaoxi',
        dangerouslyUseHTMLString: true,
        message: `<p style="cursor: pointer;width:240px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                  ${msg}
                  </p>`,
        onClick: () => {
          if (data.user_id > 0) {
            sessionStorage.setItem('selectedChatUserId', data.user_id)
          }
          this.$router.push({ path: '/chat' }).catch(() => {
            Bus.$emit('selectedChatUserId')
            //this.$router.push("/refresh");
          })
        }
      });
    })
  },
  mounted() {
    //绕过节流——在后台播放“无声音乐”
    this.keepAliveViaAudio()
    if(this.$global.token) {
      this.apiInitHandel()
    }
  },
  beforeDestroy() {
    this.$ws.removeFn('msg')
    Bus.$off('audioChanged')
    let obj = document.documentElement || window.pageYOffset || document.body
    if (obj.removeEventListener) {
      obj.removeEventListener("click", this.autoPlayHandler, false)
    } else {
      obj.detachEvent("onclick", this.autoPlayHandler)
    }
    if (this.notifyInstance) {
      this.notifyInstance.close()
    }
  },

  data() {
    return {
      isCollapse: true,
      // 响应式保存当前的权限状态：'default', 'granted', 'denied'
      permissionStatus: typeof window !== 'undefined' && window.Notification ? Notification.permission : 'unsupported',
      // 用于保存当前通知实例的引用，方便在组件销毁时清理
      notifyInstance: null
    };
  },

  methods: {
    keepAliveViaAudio() {
      const audio = document.createElement('audio');
      audio.controls = false;
      audio.loop = true;
      audio.hidden = true;
      // 一段极小的、无声的 MP3 Base64 编码
      audio.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQQAAAAAAAQA";

      audio.volume = 0.01;
      // 注意：部分浏览器要求必须有用户交互（如点击页面）后才能触发 play()
      document.addEventListener('click', () => {
        // console.log('触发音频播放')
        audio.play().catch(err => console.log("音频播放失败", err));
      }, {once: true});

      document.body.appendChild(audio);
    },

    Notification(title, bodyText, userId = 0) {
      this.notifyInstance = new Notification(title || '收到一条新消息', {
        body: bodyText,
        icon: "/img/logo.png",
        tag: "chat-msg",
        renotify: true
      })
      this.notifyInstance.onclick = (event) => {
        event.preventDefault();
        window.focus();
        if (userId > 0) {
          sessionStorage.setItem('selectedChatUserId', userId)
        }
        this.$router.push({ path: '/chat' }).catch(() => {
          Bus.$emit('selectedChatUserId')
          //this.$router.push("/refresh");
        })
      };
      this.notifyInstance.onclose = () => {
        this.notifyInstance = null;
      }
    },
    async apiInitHandel() {
      // let loading = this.$loading()
      // const { success, data } = await apiInit()
      // loading.close()
      // if(!success) return
      // this.$global.adminUser = data.user
      // if(data.user.notice) return this.$refs.DaoQiPop.onShow(data.user)
      //ALL组件已经初始化过了不需要重新初始化
      let user = this.$global.adminUser
      if (user.notice) return this.$refs.DaoQiPop.onShow(user)
    },

    // 监听页面根元素的点击事件静音全部播放一次
    triggerAllSlicePlay() {
      let obj = document.documentElement|| window.pageYOffset || document.body
      addEventListener(obj, 'click', this.autoPlayHandler);
    },

    // 处理静音全部播放一次 + 请求桌面通知权限
    autoPlayHandler() {
      let obj = document.documentElement|| window.pageYOffset || document.body
      if(this.$global.autoPlayFlag) {
        // 已经静音播放过一次，移除监听
        if (obj.removeEventListener) {
          obj.removeEventListener("click", this.autoPlayHandler, false)
        } else {
          // ie8及以下，只支持事件冒泡
          obj.detachEvent("onclick", this.autoPlayHandler)
        }
      } else {
        // 还没静音播放一次，先播一次解锁浏览器音频策略
        if (this.$refs.AudioPlay) this.$refs.AudioPlay.sliceAllPlay()
      }

      // 谷歌桌面通知权限请求（必须在用户手势中触发）
      if (!("Notification" in window)) return
      if (this.permissionStatus === 'granted') return
      Notification.requestPermission().then(permission => {
        this.permissionStatus = permission
        if (this.permissionStatus === 'denied') {
          this.$message({
            message: "通知权限已被拦截，请点击地址栏左侧的锁头/滑块图标重新开启。",
            type: 'warning',
            duration: 10000
          });
        }
      })
    }
  }
};
</script>

<style lang="scss">
.v_layout {
  height: 100%;
  .el-container {
    flex-direction: column;
  }
  .el-main{
    flex-basis: 0%;
  }
}
.el-notification {
  cursor: pointer;
}
</style>
